// Copyright (c) 2016 Deere & Company

import actions from '../../actions-list';
import {filterSearchResults} from '../../shared/services/pip-search-helper';

export const resetAllFacets = (dealerAccounts, pipTypes) =>

    (dispatch, getState) => {

        const defaultSearchResults = getState().pips.pipSearch.searchResults;

        dispatch({
            dealerAccounts,
            pipTypes,
            type: actions.RESET_PIP_SEARCH_FILTERS
        });

        dispatch({
            data: defaultSearchResults,
            type: actions.FILTER_PIP_SEARCH_RESULTS
        });

    };

export const selectAllDealersOnInitialLoad = allowedDealers => ({
    allowedDealers,
    type: actions.SELECT_ALL_PIP_SEARCH_DEALER_ACCOUNT_FACET_ITEMS
});

export const toggleDealerAccountFacetItems = allowedDealers => ({
    allowedDealers,
    type: actions.TOGGLE_PIP_SEARCH_DEALER_ACCOUNT_FACET_ITEMS
});

export const togglePipTypeFacetItems = allowedTypes => ({
    allowedTypes,
    type: actions.TOGGLE_PIP_SEARCH_PIP_TYPE_FACET_ITEMS
});

export const updateDealerAccountFacetItem = (dealerAccount, isSelected) => ({
    dealerAccount,
    isSelected,
    type: actions.UPDATE_PIP_SEARCH_DEALER_ACCOUNT_FACET_ITEM
});

export const updatePipTypeFacetItem = (pipType, isSelected) => ({
    isSelected,
    pipType,
    type: actions.UPDATE_PIP_SEARCH_PIP_TYPE_FACET_ITEM
});

export const applySearchFilters = props =>

    dispatch => {

        const pipSearchDetails = {
            isValidDealer: props.isValidDealer,
            searchByType: props.searchByType,
            searchResults: props.searchResults,
            selectedDealers: props.facets.dealerAccountsFacet.selectedDealers,
            selectedPipTypes: props.facets.pipTypesFacet.selectedTypes
        };

        dispatch({
            data: filterSearchResults(pipSearchDetails),
            type: actions.FILTER_PIP_SEARCH_RESULTS
        });

    };



// WEBPACK FOOTER //
// ./src/pip/pip-search/action-creators/facets.js